export default class City {
  #name = ''
  #code = ''

  static fromJSONResponse(json) {
    return new City()
      .setName(json.name)
      .setCode(json.code)
  }

  getName() {
    return this.#name
  }

  getCode() {
    return this.#code
  }

  setName(value) {
    this.#name = value
    return this
  }

  setCode(value) {
    this.#code = value
    return this
  }
}
